export interface PasswordRequirementStatus {
  id: PasswordRequirementId;
  label: string;
  met: boolean;
}

export type PasswordRequirementId = 'length' | 'uppercase' | 'lowercase' | 'digit';

const RULES = [
  {
    id: 'length' as const,
    label: 'At least 8 characters',
    test: (password: string) => password.length >= 8,
  },
  {
    id: 'uppercase' as const,
    label: 'One uppercase letter',
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    id: 'lowercase' as const,
    label: 'One lowercase letter',
    test: (password: string) => /[a-z]/.test(password),
  },
  {
    id: 'digit' as const,
    label: 'One number',
    test: (password: string) => /[0-9]/.test(password),
  },
] as const;

export const PASSWORD_REQUIREMENTS = RULES.map(({ id, label }) => ({ id, label }));

export function evaluatePassword(password: string): PasswordRequirementStatus[] {
  return RULES.map(({ id, label, test }) => ({
    id,
    label,
    met: test(password),
  }));
}

export function isStrongPassword(password: string): boolean {
  return evaluatePassword(password).every(({ met }) => met);
}

export const isPasswordValid = isStrongPassword;

export function passwordPolicyError(password: string): string | null {
  const unmet = evaluatePassword(password).filter(({ met }) => !met);
  if (unmet.length === 0) return null;

  return `Password needs: ${unmet.map(({ label }) => label).join('; ')}.`;
}
